import PropTypes from 'prop-types';
import Icon from "../../../Display/Icon/Icon";
import StatusToolTip from "./StatusToolTip";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function RequiresSpecializedScreeningLabel(_ref) {
  let {
    showRequiresFeeScheduleScreening,
    className,
    programId
  } = _ref;
  if (!showRequiresFeeScheduleScreening) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [/*#__PURE__*/_jsx(Icon, {
      icon: "ExclamationTriangle",
      className: "pr-1",
      color: "text-blue"
    }), /*#__PURE__*/_jsx("span", {
      className: "align-middle font-medium-font",
      children: "Requires specialized screening"
    }), /*#__PURE__*/_jsx(StatusToolTip, {
      description: "requires_specialized_screening__tool-tip",
      toolTip: "This program requires that the client complete a specialized screening before receiving services.",
      className: "ml-1",
      programId: programId,
      tooltipPosition: "bottom"
    })]
  });
}
RequiresSpecializedScreeningLabel.propTypes = {
  showRequiresFeeScheduleScreening: PropTypes.bool,
  className: PropTypes.string,
  programId: PropTypes.string.isRequired
};
RequiresSpecializedScreeningLabel.defaultProps = {
  showRequiresFeeScheduleScreening: false,
  className: ''
};
export default RequiresSpecializedScreeningLabel;
//# sourceMappingURL=RequiresSpecializedScreeningLabel.js.map